export default __webpack_public_path__ + "static/SRUS SC105 - Product Specifications & Technical Data-2839c26545b66cd55809c1a0668ae127.pdf";